import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { useRegister } from "./context";

/**
 * Route guards (T07-22): no open shift → the open-shift screen (reports / history / settings stay
 * reachable); a feature the register does not offer (免税 without the licence, `features.taxFree`
 * false) → back to the sale screen.
 */
export function RequireShift({ children }: { children: ReactNode }) {
  const register = useRegister();
  if (register.isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 aria-hidden className="size-10 animate-spin" />
      </div>
    );
  }
  if (register.data && !register.data.openShift) {
    return <Navigate to="/shift" replace />;
  }
  return <>{children}</>;
}

export function RequireFeature({ feature, children }: { feature: "taxFree"; children: ReactNode }) {
  const register = useRegister();
  if (register.data && register.data.features[feature] === false) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
